import { createContext, useContext, useEffect, useState } from "react";

const PublicThemeContext = createContext({ light: false, toggle: () => {} });

export const usePublicTheme = () => useContext(PublicThemeContext);

export function PublicThemeProvider({ children }) {
  const [light, setLight] = useState(() => {
    try { return localStorage.getItem("publicTheme") === "light"; } catch { return false; }
  });
  useEffect(() => {
    try { localStorage.setItem("publicTheme", light ? "light" : "dark"); } catch { /* ignore */ }
  }, [light]);
  return (
    <PublicThemeContext.Provider value={{ light, toggle: () => setLight((v) => !v) }}>
      {children}
    </PublicThemeContext.Provider>
  );
}
